import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { CardMembership } from '@material-ui/icons';

const LicenseExpiredPage = () => {
    const { translation } = useTypedTranslation();

    return (
        <>
            <div className='help'>
                <div className='tile help__button'>
                    <div className='help__icon'>
                        <CardMembership style={{ fontSize: 60 }} />
                    </div>
                    <div className='help__content'>
                        <p>{translation('BILLING_LICENSE_EXPIRED_1')}</p>
                        <p>{translation('BILLING_LICENSE_EXPIRED_2')}</p>
                        <p>{translation('BILLING_LICENSE_EXPIRED_3')}</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LicenseExpiredPage;